import { AssignmentNotification, NotificationType } from "../../../../types/scheduling/meetings";
import { WeekendNotificationFlag } from "../../../../types/scheduling/midweek";
import { WMCoreParts } from "../../../../types/scheduling/weekend";
import { notificationStatePart } from "../../notificationStatus";
import { hasAbsence } from "../../../../helpers/absence";
import { stringToDate } from "../../../../helpers/dateHelpers";
import { Absence } from "../../../../types/scheduling/absence";
import { ISODateString } from "../../../../types/date";

// Map of part types to notification flags
const WMPartTypeFlag = new Map<WMCoreParts, WeekendNotificationFlag>([
  [WMCoreParts.Chairman, WeekendNotificationFlag.WMChairmanFlag],
  [WMCoreParts.WTConductor, WeekendNotificationFlag.WMWTConductorFlag],
  [WMCoreParts.Reader, WeekendNotificationFlag.WMReaderFlag],
  [WMCoreParts.OpeningPrayer, WeekendNotificationFlag.WMOpeningPrayerFlag],
  [WMCoreParts.ClosingPrayer, WeekendNotificationFlag.WMClosingPrayerFlag],
  [WMCoreParts.Host, WeekendNotificationFlag.WMHospitalityFlag],
  [WMCoreParts.Interpreter, WeekendNotificationFlag.WMInterpreterFlag],
]);

export interface UseAssignmentNotificationsProps {
  part: WMCoreParts;
  scheduleId: number;
  assigneeId: number;
  meetingDate: ISODateString;
  notifications?: AssignmentNotification[];
  absences?: Absence[];
}

export function useAssignmentNotifications({
  part,
  scheduleId,
  assigneeId,
  meetingDate,
  notifications,
  absences,
}: UseAssignmentNotificationsProps) {
  // Get the notification flag for this part type
  const flag = WMPartTypeFlag.get(part);

  // Find the notification for this part
  const notification = flag
    ? notifications
        ?.filter((n) => n.type === NotificationType.WeekendCRH)
        .find((n) => n.flag === flag && n.part === scheduleId)
    : undefined;

  // Get the notification state
  const notificationState = notificationStatePart(assigneeId, notification);

  // Check if the assignee has an absence on this date
  const hasConflictingAbsence = assigneeId ? hasAbsence(assigneeId, stringToDate(meetingDate), absences) : false;

  return {
    notification,
    notificationState,
    hasConflictingAbsence,
  };
}
